import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Store} from "@ngxs/store";
import {Emittable, Emitter} from '@ngxs-labs/emitter';
import {TranslateService} from "@ngx-translate/core";
import {DataState} from '../../store/data.state';

@Injectable({
  providedIn: 'root'
})
export class PrepareResolver implements Resolve<undefined> {

  @Emitter(DataState.startFlow)
  private requestToken!: Emittable;

  @Emitter(DataState.getFEConfigurationOnStart)
  private getFEConfiguration!: Emittable<string>;
  @Emitter(DataState.saveLanguage)
  private saveLanguage!: Emittable<string>;

  constructor(private readonly translateService: TranslateService, private readonly store: Store) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<undefined> {
    const lang = route.paramMap.get('language')!;
    this.translateService.use(lang);
    this.saveLanguage.emit(lang)
    this.requestToken.emit();
    const flowIdFromSession = this.store.selectSnapshot<string>((state: any) => state.whitebricks.flowId);
    if (flowIdFromSession) {
      this.getFEConfiguration.emit(flowIdFromSession);
    }
    return of(undefined);
  }

}
